module.exports = __webpack_public_path__ + "img/s.ea2efb6e.jpg";